'use strict';

// Fund workspace — a funding pool with running balances. No associations/children in the schema graph, so an
// overview-only detail screen (Identity + Balances + Description).
module.exports = {
	Identifier: 'FundWorkspace', Ordinal: 250,
	Entity: { Name: 'Fund', IDField: 'IDFund', Collection: 'Funds', GUIDField: 'GUIDFund' },
	Header: { Eyebrow: 'Fund', Title: (r) => r.Name || `Fund ${r.IDFund}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Fund/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'CostCenter', Label: 'Cost Center', Mono: true }, { Key: 'ExternalAccountID', Label: 'External Account ID', Mono: true }, { Key: 'Active', Label: 'Active', Format: 'bool' } ] },
		{ Name: 'Balances', Fields: [ { Key: 'OriginalBalance', Label: 'Original Balance', Format: 'currency' }, { Key: 'Balance', Label: 'Balance', Format: 'currency' }, { Key: 'TotalCommitted', Label: 'Total Committed', Format: 'currency' }, { Key: 'CommittedBalance', Label: 'Committed Balance', Format: 'currency' }, { Key: 'TotalPendingCharge', Label: 'Pending Charge', Format: 'currency' } ] },
		{ Name: 'Detail', Fields: [ { Key: 'Description', Label: 'Description', Wide: true } ] },
	],
};
